export const SUBSCRIPTION_TAGS = [
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'streaming', label: 'Streaming' },
  { value: 'software', label: 'Software' },
  { value: 'utilities', label: 'Utilities' },
  { value: 'hosting', label: 'Hosting' },
  { value: 'domains', label: 'Domains' },
  { value: 'music', label: 'Music' },
  { value: 'gaming', label: 'Gaming' },
  { value: 'education', label: 'Education' },
  { value: 'storage', label: 'Storage' },
  { value: 'business', label: 'Business' },
  { value: 'productivity', label: 'Productivity' },
  { value: 'security', label: 'Security' },
  { value: 'other', label: 'Other' }
]; 